import React, { Component } from 'react';
import { createStore, applyMiddleware, compose } from 'redux';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';
import { createHashHistory } from 'history';
import { ConnectedRouter, routerMiddleware } from 'react-router-redux';
import { IntlProvider } from 'react-intl';

import { getLocale } from 'LOCALES';

import reducers from 'BROWSER_TEST/reducers';
import App from 'BROWSER_TEST/containers/app';

const { messages, locale } = getLocale();

const history = createHashHistory();
const createdRouterMiddleware = routerMiddleware(history);
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

let enhancer = applyMiddleware(thunk, createdRouterMiddleware);
enhancer = process.env.NODE_ENV === 'development' ? composeEnhancers(enhancer) : enhancer;

const store = createStore(reducers, undefined, enhancer);

export default class Main extends Component {
  render() {
    return (
      <IntlProvider locale={locale} messages={messages}>
        <Provider store={store}>
          <ConnectedRouter history={history}>
            <App />
          </ConnectedRouter>
        </Provider>
      </IntlProvider>
    );
  }
}
